// Copyright (c) 2017 Deere & Company

import actions from '../../actions-list';

export const closeModal = () =>

    dispatch => {

        document.body.classList.remove('warranty-modal-is-open');

        dispatch({
            type: actions.CLOSE_TABM_SPA_CLAIM_MODAL
        });

    };

export const openModal = actionToTake =>

    dispatch => {

        document.body.classList.add('warranty-modal-is-open');

        dispatch({
            data: actionToTake,
            type: actions.OPEN_TABM_SPA_CLAIM_MODAL
        });

    };

export const updateInternalDeereComments = data => ({
    data,
    type: actions.UPDATE_TABM_SPA_CLAIM_INTERNAL_DEERE_COMMENTS
});

export const updateCommentsToDealer = data => ({
    data,
    type: actions.UPDATE_TABM_SPA_CLAIM_COMMENTS_TO_DEALER
});



// WEBPACK FOOTER //
// ./src/tabm/spa-details/action-creators/modal.js